import { Stack, Typography } from "@mui/material";
import { AlertPopover, AlertPopoverProps } from "@sinch/components/AlertPopover/AlertPopover";
import { ensureArray } from "ramda-adjunct";
import React, { FC } from "react";

export interface CellPopupProps extends AlertPopoverProps<Element> {
  title: string;
  content?: string[] | string | null;
}

export const CellPopup: FC<CellPopupProps> = ({ content, title, ...popoverProps }) => (
  <AlertPopover {...popoverProps}>
    <Stack spacing={0.5}>
      <Typography component="span" variant="descriptionTinySemi">
        {title}
      </Typography>
      {ensureArray(content).map((item, index) => (
        <Typography key={index} component="span" variant="descriptionTinyBold">
          {item}
        </Typography>
      ))}
    </Stack>
  </AlertPopover>
);
